module.exports = __webpack_public_path__ + "img/Postbank.782c55d9.svg";